import React from "react";

export default function UserLockersHistoryComponent({locker}) {

    const formatDateTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const datePart = date.toLocaleDateString('en-GB'); 
    const timePart = date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });

    return `${datePart} at ${timePart}`;
  };

  console.log("histroy lockre data :", locker);
  return (
    <div className="locker-card">
      <div className="top">
        <div className="title">{locker?.locker_bank_name}</div>
        <div className="status">{locker?.status}</div>
      </div>

      <div className="sub-text">{locker?.door_size} locker <span> # Door number: {locker?.door_number}</span></div>
      
      <div className="date-section">
          <div className="date-box">
            <span className="label">Check-in</span>
            <span className="value">{formatDateTime(locker.reserve_start)}</span>
          </div>

          <div className="date-box">
            <span className="label">Check-out</span>
            <span className="value">{formatDateTime(locker.reserve_end)}</span>
          </div>
        </div>


      <hr />

      <div className="total">Total: $ {locker?.amount}</div>
    </div>
  );
}